import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";

import { Section, Title, Text, Span } from "../../components/Core";
import imgPhoto from "../../assets/image/jpg/foto.jpg";
import imgSignLight from "../../assets/image/png/jorge-signature.png";

const LinkSocial = styled.a`
  color: ${({ theme }) => theme.colors.light} !important;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 13px;
  letter-spacing: 1.63px;
  transition: 0.4s;
  &:hover {
    color: ${({ theme }) => theme.colors.light} !important;
    transform: translateY(-5px);
  }
`;

const About = ({ hero = true, bg = "dark", ...rest }) => {
  return (
    <>
      <Section hero={hero} bg={bg} {...rest}>
        <Container>
          <Row className="align-items-center">
            <Col lg="6">
              <div>
                <img src={imgPhoto} alt="folio" className="img-fluid" />
              </div>
            </Col>
            <Col lg="6">
              <div className="pl-lg-4 pt-5 pt-lg-0">
                <Title color="light" variant="secSm">
                  Jorge Soto
                </Title>
                <Text
                  color="light"
                  className="mt-3 mt-lg-5"
                  css={`
                    line-height: 1.5;
                  `}
                >
                  Hi!, let me introduce myself,I am Sotware Developer and IT Assistant with 18 years of experience, it is a pleasure to show you who I am. The goal of this personal website is to tell the world that through tecnology like ReactJS, I can help someone in any part of the world to build a web application project that can help them to achieve their goals to improve their lives personally or in their business managing. Please do not hesitate to reach me, I am already imaging, enjoying and developing that project that you have in mind.
                </Text>
       
                <div className="mt-4">
                  <Text color="light">Email me at</Text>

                  <Text variant="p">
                    <a
                      href="mailto:san_lucas2005@yahoo.com"
                      className="font-weight-bold"
                    >
                      <Span color="light">san_lucas2005@yahoo.com</Span>
                    </a>
                  </Text>
                </div>
                <div className="mt-5">
                  <img src={imgSignLight} alt="sign" className="img-fluid" />
                </div>
                <Text color="light" className="mt-3 font-weight-bold">
                  Jorge Soto
                </Text>
                <Text color="light" variant="small">
                  Founder of Websites Para Tu Negocio
                </Text>
                <div className="mt-5 d-flex">
                  <LinkSocial
                    href="https://www.linkedin.com/in/jorge-soto-at-cabo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mr-3"
                  >
                    Linkedin
                  </LinkSocial>
                  <LinkSocial
                    href="https://github.com/jorgeatcabo"
                    target="_blank"
                    rel="noopener noreferrer"
                    className=" mr-3"
                  >
                    GitHub
                  </LinkSocial>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </Section>
    </>
  );
};

export default About;
